export const getBreadCrumb = (area, pref, pageName) => {
  if (!area) {
    return [
      { text: 'ライブカメラ' }
    ]
  } else if (!pref) {
    if (area === 'okinawa') {
      return [
        { text: 'ライブカメラ', link: '../' },
        { text: getPrefectureName(area) }
      ]
    }
    return [
      { text: 'ライブカメラ', link: '../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name }
    ]
  } else if (pageName) {
    return [
      { text: 'ライブカメラ', link: '../../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../../' },
      { text: getPrefectureName(pref), link: '../' },
      { text: pageName }
    ]
  } else {
    return [
      { text: 'ライブカメラ', link: '../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../' },
      { text: getPrefectureName(pref) }
    ]
  }
}
